import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 20389 16881"
    {...props}
  >
    <path
      d="M4397 13787c0 590 2 1170-1 1749 0 141-4 283-24 421-72 498-450 884-949 899-821 24-1643 24-2464-1-504-16-892-428-938-934-24-255-19-514-19-771-2-1046-3-2092 0-3138 3-951-7-1902 29-2852 12-313 116-636 238-930 724-1745 1468-3481 2198-5224 312-744 628-1484 1201-2075C4232 350 4923 20 5728 15 8676-3 11623-1 14570 2c280 1 565 35 838 96 934 210 1617 784 2049 1608 383 731 681 1508 996 2273 514 1249 994 2513 1522 3756 475 1119 447 2277 368 3450-14 210 35 424 36 637 4 1295 8 2590-1 3885-5 733-435 1158-1164 1168-648 8-1296 8-1943 0-729-11-1151-445-1155-1175-2-615-1-1229-2-1844 0-16-6-32-13-68-3886-1-7774-1-11704-1zm13803-7248c-3-33 1-58-8-77-575-1239-1143-2481-1729-3716-407-857-1031-1385-2051-1378-2763 17-5526 9-8290 3-743-2-1345 250-1748 894-131 210-250 430-359 653-544 1116-1083 2235-1624 3352-34 72-67 145-118 252 1011-291 2010-173 3000-177 2946-14 5892-23 8838 3 1361 13 2734-163 4089 191zm-7883 3588H7756c-457 0-700 170-698 489 2 321 239 487 702 487 1683 0 3365 0 5048-1 107 0 232 18 317-30 134-76 290-177 349-308 148-327-112-633-521-636-879-4-1757-1-2636-1zm-6801-406c-381 0-762-5-1143 1-467 8-791 309-803 738-13 429 294 779 752 791 794 20 1590 20 2384 0 460-12 764-358 753-789s-332-731-800-739c-381-7-762-2-1143-2zm13294 1521v6c415 0 832 23 1244-7 427-30 721-390 698-792-22-411-339-720-771-725-789-8-1577-2-2366-1-259 0-467 109-616 318-333 469-60 1132 518 1192 427 44 862 9 1293 9z"
      style={{
        fill: "#000",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
